import VueRouter, { Route } from 'vue-router';
import { OrdersStoreDraftModule } from './../../orders/store/draft/module';
export async function draftSessionGuard(router: VueRouter, to: Route) {
  const query = to.query.customer ? `?customer=${to.query.customer}` : '';

  await OrdersStoreDraftModule.fetchSessionId();
  if (OrdersStoreDraftModule.sessionId) router.push(`/orders/create/${OrdersStoreDraftModule.sessionId}${query}`);
}
